import { produce } from "immer";
import * as Actions from "pages/Settings/ActiveDevices/store/failedSessionsActions";

const initialState = { byId: {}, data: [], message: null };
const failedSessionsReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_FAILED_SESSIONS_SUCCESS: {
      const payload = action.payload;
      draft.data = payload.failedSessions;
      draft.byId = {};
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default failedSessionsReducer;
